import React from 'react';
import { motion } from 'framer-motion';
import { FacebookIcon, InstagramIcon, MailIcon, YoutubeIcon } from 'lucide-react';
import { Badge } from './Badge';
export function Contact() {
  return <section id="contact" className="relative w-full bg-[var(--vu-red)] py-20 px-5 overflow-hidden grain" data-id="element-17" data-mp="315s38dq02oau">
      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-18" data-mp="2w8s5cq3b0rut">
        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-6" data-id="element-19" data-mp="3sy9drcto8s07">
          <Badge size={96} data-id="element-20" data-mp="3k3be7mw0qgzw" />
        </motion.div>

        <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none text-stroke-black" data-id="element-21" data-mp="3f74jkq92orx9">
          Let's Play Your Party
        </h2>
        <p className="mt-4 font-body text-[var(--vu-cream)]/90 text-base max-w-xl mx-auto" data-id="element-22" data-mp="bpmc4jx7pmxd">
          Booking a wedding, a corporate night, or just want us at your favorite bar? Reach out and
          let's put a set together.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-4" data-id="element-23" data-mp="3otmh6yadoju8">
          <a href="https://www.youtube.com/@VirtuallyUnknownBand" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-navy)] text-[var(--vu-cream)] font-cond uppercase tracking-wider px-6 py-3 border-2 border-[var(--vu-gold)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-24" data-mp="3b3svupy30hp9">
            <YoutubeIcon className="w-5 h-5" data-id="element-25" data-mp="2w60gpywg5vbl" />
            YouTube
          </a>
          <a href="https://www.instagram.com/nicksettemusic" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-navy)] text-[var(--vu-cream)] font-cond uppercase tracking-wider px-6 py-3 border-2 border-[var(--vu-gold)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-26" data-mp="2w8340b67tacm">
            <InstagramIcon className="w-5 h-5" data-id="element-27" data-mp="1ubp1sh5b5a5x" />
            @nicksettemusic
          </a>
          <a href="https://www.facebook.com/61574932536941" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-navy)] text-[var(--vu-cream)] font-cond uppercase tracking-wider px-6 py-3 border-2 border-[var(--vu-gold)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-28" data-mp="1pcuile3fhjla">
            <FacebookIcon className="w-5 h-5" data-id="element-29" data-mp="35psuzl42mu9x" />
            Virtually Unknown
          </a>
          <a href="mailto:nicksettemusic@gmail.com" className="inline-flex items-center gap-2 bg-[var(--vu-gold)] text-[var(--vu-black)] font-cond uppercase tracking-wider px-6 py-3 border-2 border-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-30" data-mp="30zcchmle8igp">
            <MailIcon className="w-5 h-5" data-id="element-31" data-mp="3maa0bprmfhpw" />
            Booking Inquiry
          </a>
        </div>
      </div>
    </section>;
}